export default __webpack_public_path__ + "static/media/fireflink-ai.99048d48.svg";